import { createFileRoute } from '@tanstack/react-router';
import { ClientDetailView } from '@/components/company/clients/detail/client-detail';

export const Route = createFileRoute('/(app)/company/clients/$clientId')({
  component: ClientDetailRoute,
});

function ClientDetailRoute() {
  const { clientId } = Route.useParams();

  return <ClientDetailView clientId={Number(clientId)} />;
}
